
// src/actions/alert-message.js

import { pushRoute } from './route'

export const EMIT_ALERT_MESSAGE = "EMIT_ALERT_MESSAGE"
export const CLEAR_ALERT_MESSAGE = "CLEAR_ALERT_MESSAGE"

function handleError(message) {
  var trial_expired = false;
  var re_trial = false;

  switch (message.status) {
    case 401:
    case 402:
    case 410:
      trial_expired = message.status == 402 || !!(message.error[0] && message.error[0].match(/無料トライアル期間が終了/));
      re_trial = message.status == 410 || !!(message.error[0] && message.error[0].match(/お客様のトライアル期間は終了/));
      pushRoute('login')
      break;
    case 503:
      pushRoute('unavailable');
      break;
    case 404:
      if (message.error.code && message.error.code.match(/MailboxNotEnabledForRESTAPI/)) {
        message = 'error:MSアカウント';
      }
      break;
  }

  return { trial_expired: trial_expired, re_trial: re_trial, message: message };
}

export function emitAlertMessage(message, category) {
  var result = message.error ? handleError(message) : { message: message };
  var alertMessage = result.message.error ? result.message.error : result.message;

  return {
    type: EMIT_ALERT_MESSAGE,
    message: alertMessage,
    category: category,
    trial_expired: result.trial_expired,
    re_trial: result.re_trial
  };
}

export function clearAlertMessage() {
  return {
    type: CLEAR_ALERT_MESSAGE
  }
}




// WEBPACK FOOTER //
// ./src/actions/alert-message.js